import styled from 'styled-components';
import { color } from '../../../resources';

export const StyledContainer = styled.div`
  background-color: ${color.white};
  padding: 16px;
`;
export const StyledEnterTelContainer = styled.div`
  background-color: ${color.white};
  padding: 16px;
  margin-top: 10px;
  width: 100%;
  padding-left: 20px;
  overflow-y: auto;
`;
export const StyledOtpContainer = styled.div`
  background-color: ${color.white};
  margin-top: 30px;
`;

export const HomePageStyledContainer = styled.div`
  background-color: transparent;
  position: fixed;
  top: 65px;
  width: 100%;
  padding-left: 20px;
`;
export const RegisterStyledContainer = styled.div`
  width: 100%;
  background-color: ${color.content_background};
  overflow-y: auto;
  height: 100%;
`;
export const InfoHeaderStyledContainer = styled.div`
  text-align: center;
  background: #fff3cd;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const StyledCard = styled.div`
  border-radius: 0px 25px 25px 0px;
  padding: 5px 5px 0 0;
  box-sizing: border-box;
  line-height: 1.5714285714285714;
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  margin-bottom: 10px;
`;
